import { render, staticRenderFns } from "./ViewVehicles.vue?vue&type=template&id=3323048b"
import script from "./ViewVehicles.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewVehicles.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports